import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { inputStyle } from './styles.ts';

import { InputContent } from '@/components/common/InputContent/InputContent.tsx';

const NAME_MAX_LENGTH = 30;

type NameInputProps = {
  name: string;
  updateFields: (fields: Partial<{ name: string }>) => void;
};

export const NameInput = ({ name, updateFields }: NameInputProps) => {
  const { t } = useTranslation();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ\s]/g, '');
    updateFields({ name: value });
  };

  return (
    <InputContent
      title={t('name_section').toUpperCase()}
      styleTitle={{ fontWeight: 510, fontSize: 12, color: '#787878' }}
    >
      <input
        placeholder={t('name_placeholder')}
        value={name}
        onChange={handleChange}
        maxLength={NAME_MAX_LENGTH}
        style={{ ...inputStyle, boxSizing: 'border-box' }}
      />
    </InputContent>
  );
};
